import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../BaseUrl";
import toast from "react-hot-toast";
import CreateHealthDetail from "../components/HfrRegister/CreateHealthDeatail";

const InviteAcceptance = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [invitationData, setInvitationData] = useState(null);
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setError("No invitation token provided");
      setLoading(false);
      return;
    }

    // Call resolve endpoint on page load
    resolveInvitation(token);
  }, [token]);

  const resolveInvitation = async (invitationToken) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BaseUrl}/facility/invitations/resolve/${invitationToken}`,
        { withCredentials: true }
      );

      if (response.data.status === "VALID" && response.data.success) {
        setInvitationData(response.data.data);
        setError(null);
      } else {
        // INVALID_OR_EXPIRED status
        setError(
          response.data.message || "Invalid or expired invitation token"
        );
        setInvitationData(null);
      }
    } catch (err) {
      console.error("Error resolving invitation:", err);
      setError(
        err.response?.data?.message ||
          "Failed to validate invitation. Please try again."
      );
      setInvitationData(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Validating invitation...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
          <div className="mb-4">
            <svg
              className="mx-auto h-12 w-12 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Invitation Error
          </h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => navigate("/")}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  // If invitation is valid, show registration form
  // Pass invitation data and token to CreateHealthDetail component
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white shadow-md rounded-lg p-6 mb-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Complete Your Registration
            </h1>
            <p className="text-gray-600">
              You've been invited to join Avijo. Please complete your
              registration below.
            </p>
          </div>
          <CreateHealthDetail
            invitationToken={token}
            invitationData={invitationData}
          />
        </div>
      </div>
    </div>
  );
};

export default InviteAcceptance;

